import React from 'react';
import { connect } from 'react-redux';
import { WindowContext } from '@ff-os/shared-react/context/window/WindowContext';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { PrefabPreviewMode } from '@ff-scene-plugins/gift-shared/GiftSceneOptions';
import { noop } from 'lodash';
import { selectPrefabPreviewMode } from '../../_redux-scene';
import { useOrientation } from '../../context/Orientation';
import { usePreviewSize } from '../../context/PreviewSize';
import { PrefabPicker } from '../../prefab-picker/PrefabPicker';
import { PrefabsWindowHeader } from '../mobile/partials/PrefabsWindowHeader';
import { GiftWindowStepProps } from './giftWindowSteps';
import { GiftWindowFooter } from './partials/GiftWindowFooter';

const _PrefabsWindow = ({
    onClose, previous, next,
    previousButtonText, nextButtonText,
    prefabPreviewMode
}: Props) => {

    usePreviewSize(prefabPreviewMode === 'full' ? 'hidden' : 'small');
    useOrientation('screen');

    return (
        <WindowContext isOpen close={noop}>
            <WindowContext.Header>
                <PrefabsWindowHeader previous={previous} onClose={onClose} />
            </WindowContext.Header>
            <WindowContext.Body>
                <PrefabPicker />
            </WindowContext.Body>
            <WindowContext.Footer>
                <GiftWindowFooter
                    next={next} nextButtonText={nextButtonText}
                    previous={previous} previousButtonText={previousButtonText}
                    onClose={onClose} />
            </WindowContext.Footer>
        </WindowContext>
    );
};

type Props = GiftWindowStepProps & {
    prefabPreviewMode: PrefabPreviewMode;
};

const mapStateToProps = (state: GiftPdpState) => ({
    prefabPreviewMode: selectPrefabPreviewMode(state)
});

export const PrefabsWindow = connect(
    mapStateToProps
)(_PrefabsWindow);